import { formatEntityName, formatRoleName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
import { buildOperations, validateRole } from '../../utils';
export const aclDenyEntityStmtInstruction = `
#### Denying access to entities
- Syntax: \`deny <role1>[, <role2>] to <accessTypes> entity <entityName>;\`
- Example: \`deny editor to create entity article;\`
- Example: \`deny editor to read, create, update, delete entity article;\`
`;
export const stmtAclDenyEntity = ({ roleNames, accessTypes, entityName }) => {
    return `deny ${roleNames.join(', ')} to ${accessTypes.join(', ')} entity ${entityName};`;
};
export const stmtForHumanAclDenyEntity = ({ roleNames, accessTypes, entityName }) => {
    return `Deny the roles __${roleNames.join(', ')}__ to ${accessTypes.join(', ')} the entity __${entityName}__.`;
};
export const aclDenyEntityHandler = createSchemaStatementHandler({
    type: 'deny entity',
    parse: line => {
        const match = /^deny (?<roleNames>[\w, ]+) to (?<accessTypes>[\w, ]+) entity (?<entityName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'deny entity',
                roleNames: match.groups.roleNames.split(',').map(it => formatRoleName(it.trim())),
                accessTypes: match.groups.accessTypes
                    .split(',')
                    .map(item => item.trim())
                    .filter((it) => ['delete', 'create', 'update', 'read'].includes(it)),
                entityName: formatEntityName(match.groups.entityName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanAclDenyEntity,
    apply: (stmt, builder) => {
        builder.updateSchema(it => {
            const entity = it.schema.model.entities[stmt.entityName];
            if (!entity) {
                throw new Error(`Entity ${stmt.entityName} does not exist`);
            }
            let updatedSchema = it;
            for (const role of stmt.roleNames) {
                validateRole(role);
                const operations = buildOperations({ entity, accessTypes: stmt.accessTypes, predicate: false });
                updatedSchema = updatedSchema.createAclRole(role).updatePermissionsEntity(role, stmt.entityName, {
                    predicates: {},
                    operations,
                });
            }
            return updatedSchema;
        });
    },
});
//# sourceMappingURL=AclDenyEntityStmt.js.map